<div class="col-12 n-padding">
  <!-- Plan type Radio Buttons -->
  <p class="lead m-t-lg text-bold">{{ planTypeConfigurableData?.planType }}</p>

  <div class="form-label m-t-md">
    <tmo-radio-button
      type="radio"
      name="co-radio_sample1"
      [values]="'postpaid'"
      [selectedValue]="selectedPlanType"
      (click)="selectPlanType('POSTPAID', true)"
      aria-label="Radio"
      [disabled]="billingType === 'prepaid'"
      [id]="'tmo-radio-button-coradiosample1-3'"
    >
      <p class="content" [ngClass]="{ 'text-disabled': billingType === 'prepaid' }">
        {{ planTypeConfigurableData?.postpaid }}
      </p>
    </tmo-radio-button>
  </div>

  <div class="form-label m-t-md">
    <tmo-radio-button
      type="radio"
      name="co-radio_sample1"
      [values]="'prepaid'"
      [selectedValue]="selectedPlanType"
      (click)="selectPlanType('PREPAID', false)"
      aria-label="Radio"
      [disabled]="billingType === 'postpaid'"
      [id]="'tmo-radio-button-coradiosample1-4'"
    >
      <p class="content" [ngClass]="{ 'text-disabled': billingType === 'postpaid' }">
        {{ planTypeConfigurableData?.prepaid }}
      </p>
    </tmo-radio-button>
  </div>
</div>
